<script lang="ts" setup>
</script>

<template>
  <svg
    width="114"
    height="114"
    viewBox="0 0 114 114"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    xmlns:xlink="http://www.w3.org/1999/xlink"
  >
    <rect
      x="25"
      y="13"
      width="55"
      height="87"
      rx="6"
      stroke="#4D4E58"
      stroke-width="4"
    />
    <path
      d="M55 15H74C76.2091 15 78 16.7909 78 19V94C78 96.2091 76.2091 98 74 98H55V15Z"
      fill="#E0E5FF"
    />
    <rect
      x="43"
      y="18"
      width="17"
      height="3"
      rx="1.5"
      fill="#4D4E58"
    />
    <rect
      x="32"
      y="29"
      width="11"
      height="11"
      rx="1"
      fill="#B1BEFF"
    />
    <rect
      x="32"
      y="44"
      width="11"
      height="11"
      rx="1"
      fill="#7B90FF"
    />
    <rect
      x="47"
      y="29"
      width="11"
      height="11"
      rx="1"
      fill="#B1BEFF"
    />
    <rect
      x="47"
      y="44"
      width="11"
      height="11"
      rx="1"
      fill="#B1BEFF"
    />
    <rect
      x="62"
      y="29"
      width="11"
      height="11"
      rx="1"
      fill="#B1BEFF"
    />
    <rect
      x="60"
      y="38"
      width="32.7273"
      height="32.7273"
      rx="8"
      fill="url(#pattern0_12870_5484)"
      stroke="#4D4E58"
      stroke-width="4"
    />
    <defs>
      <pattern
        id="pattern0_12870_5484"
        patternContentUnits="objectBoundingBox"
        width="1"
        height="1"
      >
        <use
          xlink:href="#image0_12870_5484"
          transform="scale(0.005)"
        />
      </pattern>
      <image
        id="image0_12870_5484"
        width="200"
        height="200"
        xlink:href="data:image/png;base64,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"
      />
    </defs>
  </svg>
</template>
